import React from 'react'

const TailwindInput = ({ classes, label, style, isDisabled, value, styleLabel, onChange, placeHolder, isError, errorMessage, type }) => {
  return (
    <div>

      <div class="relative w-full min-w-[200px]">
        <input type={type || "text"} disabled={isDisabled} onChange={onChange} value={value} class={` ${classes} ${isDisabled ? "opacity-70 " : ""} peer w-full h-full bg-transparent text-blue-gray-700 font-sans font-normal outline
 outline-0 focus:outline-0 
  disabled:cursor-not-allowed transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200
   placeholder-shown:border-t-blue-gray-200 border border-2
    placeholder:opacity-0 focus:placeholder:opacity-100 text-sm px-3
     py-2.5 rounded-[7px] border-blue-gray-200 ${isError ? "border-red-600" : "focus:border-[#7059EF]"} `} placeholder={placeHolder}
          data-listener-added_f46700c5="true" style={{ style }} />
        <label style={{ styleLabel }} class="absolute top-[-9px] left-[20px] text-[12px] bg-white px-1">
          {label}
        </label>

        {isError && <div className='text-[13px] text-red-600'>
          {errorMessage}
        </div>}
      </div>




    </div>)
}

export default TailwindInput